export interface BriefApprovalProposalRequest {
	type: string;
	budget?: number;
	comment?: string;
	documents: BriefProposalDocument[];
}

export class BriefProposalDocument {
	documentId: number;
	proposalAmount: number;
	isRecommended: boolean;
}
